<!--
 * @Descripttion: 德运通天然气管理系统
 * @version: 1.0.0
 * @Author: xst
 * @Date: 2020-03-31 13:00:48
 * @LastEditors: xst
 * @LastEditTime: 2020-05-18 21:25:58
 -->
<template>
  <div>
    <el-aside id="asideNav">
      <div class="logo-name">
        <p v-if="$store.getters.titleShow">DYT</p>
        <!-- <p v-else>德运通天然气管理平台</p> -->
        <img class='logo' v-else src="../../../assets/logo.png" />
      </div>
      <el-menu :default-active="$route.path" class="el-menu-vertical"
               @select="selectmenu"
               :collapse="$store.getters.isCollapse"
               background-color="#03152A"
               text-color="rgba(255,255,255,.7)"
               active-text-color="#ffffff"
               :router="$store.getters.uniquerouter"
               :unique-opened="$store.getters.uniquerouter"
               :collapse-transition="true"
      >
        <template v-for="(item,index) in $store.getters.routers" v-if="!item.hidden">
          <el-submenu v-if="!item.alone && item.children.length>0" :index="index+''">
            <template slot="title">
              <i :class="item.iconCls?item.iconCls:[fa,fa-server]"></i>
              <span slot="title">{{ $t(`routeName.${item.name}`) }}</span>
            </template>

            <menu-tree :menuData="item.children"></menu-tree>

          </el-submenu>
          <el-menu-item :index="item.path" v-else>
            <i :class="item.iconCls?item.iconCls:[fa,fa-file]"></i>
            <span slot="title">{{ $t(`routeName.${item.name}`) }}</span>
          </el-menu-item>
        </template>

      </el-menu>
    </el-aside>
  </div>
</template>

<script>
  import menuTree from './menuTree'

  export default {
    name: 'asideNav',
    data(){
      return{
        outMenu: ['checkcontract','/roleAuthorize','/copyContract','/remind','/newcontract','/newadjustment','/newsupply','/','/newTransport','/fuelCardTradeList','/ETCTradeList','/planOther']//路由为这些的时候，不往tabnav添加
      }
    },
    components: {
      menuTree,
    },
    watch: {
      // 监听浏览器直接输入路由，将此路由添加到tabnavBox
      '$route.path': function (val) {
        if(!this.outMenu.includes(val)){
          this.selectmenu(val)
        }
      }
    },
    methods: {
      selectmenu (key) {
        let prevRouter =  localStorage.getItem('currentRouter');
        localStorage.setItem('prevRouter',prevRouter);
        localStorage.setItem('currentRouter',key);
        let router = this.$store.getters.routers;
        let valuena = '';
        let navTitle = function (path, routerARR,name) {
          for (let i = 0; i < routerARR.length; i++) {
            if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
              if (routerARR[i].path === path && routerARR[i].children.length < 1) {
                valuena = routerARR[i][name]
                break
              }
              navTitle(path, routerARR[i].children,name)
            }
          }
          return valuena
        }
        if(key !== '/planOther'){
          localStorage.setItem('menu_key',navTitle(key, router,'key'))
          // console.log(navTitle(key, router,'key'),'点击')
          this.$store.dispatch('addTab', {
            title: navTitle(key, router,'name'),
            path: key
          })
        }else{
          /*this.$router.push(prevRouter);*/
          let routeUrl = this.$router.resolve({  path: "/statisticsPlanOther", query: {} });
          window.open(routeUrl.href, '_blank');
        }
        /**/
      }
    }
  }
</script>

<style lang="scss">
  .logo-name{
    position: relative;
    .tip{color: red;border: 1px solid red;font-family: KaiTi;border-radius: 50%;padding: 0 3px;position: absolute;top: 64px;
      left: 48px;}
  }
.logo{
  margin:30px 0 20px 15px;
  width:150px;
}
  $top: top;
  $bottom: bottom;
  $left: left;
  $right: right;
  %w100 {
    width: 100%;
  }

  %h100 {
    height: 100%;
  }

  %cursor {
    cursor: pointer;
  }

  @mixin set-value($side, $value) {
    @each $prop in $leftright {
      #{$side}-#{$prop}: $value;
    }
  }
  .el-menu--popup{min-width: 180px;}
  #asideNav {
    width: auto !important;
    display: flex;
    flex-direction: column;
    // border-right: solid 1px #e6e6e6;
    .el-menu-item .el-tooltip{padding: 0 15px!important;}
    .logo-name {
      // width:220px;
      background-color: #03152A !important;
      @extend %w100;
      font-weight: 800;
      z-index: 999;
      p {
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-size: 20px;
        // color: #5e6d82;
        color:rgba(255, 255, 255, 0.7);
      }
    }
    .el-menu-vertical:not(.el-menu--collapse) {
      width: 180px;
      @extend %h100;
      overflow-y: auto;
      overflow-x: hidden;
    }
    .el-menu {
      flex: 1;
      overflow: inherit;
      border-right: none;
      &::-webkit-scrollbar {
        display: none;
      }
      .fa {
        vertical-align: middle;
        margin-right: 5px;
        width: 24px;
        text-align: center;
        font-size: 16px;
      }
      .el-submenu{font-size: 16px;}
      .el-menu-item,.el-submenu__title{/*width:180px;*/height: 44px!important;line-height: 44px!important;padding: 0 15px!important;}
      .el-menu-item {
        background-color: #020f1d !important;
        border-bottom: 1px solid #020f1d;
        &:hover {
          color: #ffffff !important;
          background-color: #375573 !important;
        }
      }
      .el-menu-item.is-active {
        background-color: #56a9ff !important
      }
      .is-opened > .el-submenu__title > .el-icon-arrow-down {
        color: #ffffff;
        font-weight: 500;
        font-size: 18px;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/layout/aside/aside.vue